export const PLAYER_AVATAR_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
export function isPlayerAvatarId(value) {
    return typeof value === "number" && PLAYER_AVATAR_IDS.some((id) => id === value);
}
//# sourceMappingURL=avatars.js.map